import { createSlice } from '@reduxjs/toolkit';
import { fetchInstagramDataThunk, refreshInstagramDataThunk, fetchInstagramPostsThunk, } from './instagramThunks';
// ===== INITIAL STATE =====
const initialState = {
    data: null,
    isLoading: false,
    error: null,
    lastUpdated: null,
    selectedPeriod: 'month',
};
// ===== INSTAGRAM SLICE =====
export const instagramSlice = createSlice({
    name: 'instagram',
    initialState,
    reducers: {
        // Clear error
        clearError: (state) => {
            state.error = null;
        },
        // Set loading state
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        // Set selected period
        setSelectedPeriod: (state, action) => {
            state.selectedPeriod = action.payload;
        },
        // Set Instagram data directly (for mock data)
        setInstagramData: (state, action) => {
            state.data = action.payload;
            state.lastUpdated = new Date().toISOString();
            state.error = null;
        },
        // Clear Instagram data
        clearInstagramData: (state) => {
            state.data = null;
            state.lastUpdated = null;
            state.error = null;
        },
        // Update specific post data
        updatePost: (state, action) => {
            if (state.data?.posts) {
                const postIndex = state.data.posts.findIndex(p => p.id === action.payload.postId);
                if (postIndex !== -1) {
                    state.data.posts[postIndex] = {
                        ...state.data.posts[postIndex],
                        ...action.payload.updates
                    };
                }
            }
        },
    },
    extraReducers: (builder) => {
        // ===== FETCH INSTAGRAM DATA =====
        builder
            .addCase(fetchInstagramDataThunk.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
            .addCase(fetchInstagramDataThunk.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
            state.lastUpdated = new Date().toISOString();
            state.error = null;
        })
            .addCase(fetchInstagramDataThunk.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
        // ===== REFRESH INSTAGRAM DATA =====
        builder
            .addCase(refreshInstagramDataThunk.pending, (state) => {
            // Don't set loading for refresh to avoid UI flicker
        })
            .addCase(refreshInstagramDataThunk.fulfilled, (state, action) => {
            state.data = action.payload;
            state.lastUpdated = new Date().toISOString();
            state.error = null;
        })
            .addCase(refreshInstagramDataThunk.rejected, (state, action) => {
            state.error = action.payload;
        });
        // ===== FETCH INSTAGRAM POSTS =====
        builder
            .addCase(fetchInstagramPostsThunk.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
            .addCase(fetchInstagramPostsThunk.fulfilled, (state, action) => {
            state.isLoading = false;
            if (state.data) {
                state.data.posts = action.payload;
            }
            state.lastUpdated = new Date().toISOString();
            state.error = null;
        })
            .addCase(fetchInstagramPostsThunk.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
    },
});
// ===== ACTIONS =====
export const { clearError, setLoading, setSelectedPeriod, setInstagramData, clearInstagramData, updatePost, } = instagramSlice.actions;
// ===== REDUCER =====
export default instagramSlice.reducer;
